import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=d015f8dc&scoped=true&"
import script from "./IssueDetail.vue?vue&type=script&lang=js&"
export * from "./IssueDetail.vue?vue&type=script&lang=js&"
import style0 from "./IssueDetail.vue?vue&type=style&index=0&id=d015f8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d015f8dc",
  null
  
)

export default component.exports